import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { CreateSecretInput_InputAdapter_instance2l4v3ubwtcjdq as CreateSecretInput_InputAdapter_instance } from '../type/adapter/CreateSecretInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CreateSecretMutation_VariablesAdapterClass;
function CreateSecretMutation_VariablesAdapter() {
  if (CreateSecretMutation_VariablesAdapterClass === VOID) {
    class $ {
      u6d(writer, value, customScalarAdapters, withDefaultValues) {
        writer.k4a('input');
        obj(CreateSecretInput_InputAdapter_instance).t3x(writer, customScalarAdapters, value.r6d_1);
      }
    }
    initMetadataForObject($, 'CreateSecretMutation_VariablesAdapter');
    CreateSecretMutation_VariablesAdapterClass = $;
  }
  return CreateSecretMutation_VariablesAdapterClass;
}
var CreateSecretMutation_VariablesAdapter_instance;
function CreateSecretMutation_VariablesAdapter_getInstance() {
  return CreateSecretMutation_VariablesAdapter_instance;
}
//region block: init
CreateSecretMutation_VariablesAdapter_instance = new (CreateSecretMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  CreateSecretMutation_VariablesAdapter_instance as CreateSecretMutation_VariablesAdapter_instance2r5izuppvm65o,
};
//endregion

//# sourceMappingURL=CreateSecretMutation_VariablesAdapter.mjs.map
